import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer-container">
      <p>© {new Date().getFullYear()} Sensasion Physiotherapy Clinic. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
